/**
 * 后台管理
*/
import http from '@/request/http'
export default {
  /*** 用户活跃度 ***/
  // 昨日活跃度
  getActiveYesterday: params => http.get(`/api/juji/activity/personsYesterdayNumber`, params),
  // 昨日新增用户
  getYesterdayAddUser: params => http.get(`/api/juji/activity/findNewUsersYesterdayNumber`, params),
  // 活跃度图表
  getUserActivityTable: params => http.get(`/api/juji/activity/dataList`, params),


  /*** 自定义数据 ***/
  // 获取自定义项目属性
  getProjectProperties: (params, pageId) => http.get(`/api/juji/page/${pageId}/settings`, params),
  // 新增设备、修改设备
  addNewEquipment: params => http.post(`/api/juji/additionalDevice/saveDevice`, params),
  // 添加数据
  addTelemetryData: (params, entityId, entityType) => http.post(`/api/plugins/telemetry/${entityType}/${entityId}/timeseries/scope`, params),
  // 根据设备类型获取设备属性
  getAttributeByType: params => http.get(`/api/juji/deviceTypeAttributeTelemetry/getByType`, params),

  // 获取设备列表及数据
  getEquipmentNumList: params => http.get(`/api/juji/customerProjectAttributes/additionalDevice/values/timeseries`, params),
  // 获取项目属性表格列表数据
  getProjectPropertiesList: (params, entityId) => http.get(`/api/juji/customerProjectAttributes/ASSET/${entityId}/values/timeseries/merge`, params),
  // 删除设备
  deleteDeviceItem: (params, deviceId) => http.delete(`/api/juji/additionalDevice/device/${deviceId}`, params),
  // 删除设备属性
  deleteDeviceProperties: (params, entityId) => http.delete(`/api/plugins/telemetry/DEVICE/${entityId}/timeseries/delete`, params),
  // 获取设备设置
  getDeviceSettings: params => http.get(`/api/juji/additionalDevice/info`, params),
  // 获取历史数据
  getHistoricalDataToTable: (params, entityType, entityId) => http.get(`/api/juji/customerProjectAttributes/${entityType}/${entityId}/values/timeseries/merge`, params),


  /***   指标数据配置   ***/
  // 获取指标数据配置列表
  backstageGetList: params => http.get(`/api/juji/page/settings/getByName`, params),

  /*** 关联查找 ***/
  // 通过设备查询资产
  backstageFindAssets: params => http.get(`/api/juji/device/getAssetsOfDevice`, params),
  // 通过资产查询设备
  backstageFindEquipment: params => http.get(`/api/juji/device/getDevicesStatusByAsset`, params),


}

